import { createPageApp } from '@/lib/createPageApp'
import StudyInJoyArticlesPage from './StudyInJoyArticlesPage.vue'

createPageApp(StudyInJoyArticlesPage).mount()
